export default __webpack_public_path__ + "static/media/Pokemon_05.ce1748f7.png";